export const formatDateByScale = (date: Date, scale: string | null): string => {
  const baseOptions = {
    month: 'short' as const,
    day: 'numeric' as const,
    year: 'numeric' as const,
  };

  switch (scale) {
    case 'MONTHS':
      return date.toLocaleDateString('en-US', {
        month: 'short',
        year: 'numeric',
      });

    case 'DAYS':
      return date.toLocaleDateString('en-US', baseOptions);

    case 'HOURS':
      return date.toLocaleDateString('en-US', {
        ...baseOptions,
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });

    case 'WEEKS':
      const startOfWeek = new Date(date);
      const endOfWeek = new Date(date);
      endOfWeek.setDate(date.getDate() + 6);

      const startStr = startOfWeek.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
      });
      const endStr = endOfWeek.toLocaleDateString('en-US', baseOptions);
      return `${startStr}-${endStr}`;

    default:
      return date.toLocaleDateString('en-US', {
        ...baseOptions,
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
  }
};
